import { IPostCreateTempDetail } from "./Index";

/**
 * IPostCreateTempDetail 的 默认值
 */
export const DEFAULT_TEMP_DETAIL: IPostCreateTempDetail = {
  activity_intro: {},
  head_img: { img_url: "" },
  progress: { show_type: 1 },
  reward_info: {
    show: true,
    title: "",
    reward_items: [],
  },
  act_intro_ing: {
    show: false, // 是否展示运动记录
  },
  reword_list: {
    pop_up_img: "",
    goal_reward_list: [],
    new_comer_gift_pack_reward: {
      pack_items: [],
      share_feed_img: "",
      share_feed_title: "",
      share_reward_type: 0,
      share_reward_value: "",
      share_title: "",
    },
  },
  rule_info: {
    show: false,
    title: "",
    content: "",
  },
  share_param: {
    title: "",
    content: "",
  },
  topic: {},
  start_btn: {},
  sports_record: {},
  card_info: {},
};
